import api from '@/client/core/api'

// シナリオ保存 API

export interface PutInstagramScenarioContainerNodeCardButtonParam {
  id?: number
  tempId?: string
  name: string
  url: string
}

export interface PutInstagramScenarioContainerNodeCardParam {
  title: string
  subtitle: string
  url: string | null
  mediaId: number
  button: PutInstagramScenarioContainerNodeCardButtonParam[]
}

export interface PutInstagramScenarioContainerNodeParamBase {
  type: number
  isFinally: boolean
  parentIds?: number[]
  parentTempIds?: string[]
  id?: number
  tempId?: string
}

export interface PutInstagramScenarioContainerNodeTextParam extends PutInstagramScenarioContainerNodeParamBase {
  text: string
}

export interface PutInstagramScenarioContainerNodeMediaParam extends PutInstagramScenarioContainerNodeParamBase {
  mediaId: number
}

export interface PutInstagramScenarioContainerNodeCardParam extends PutInstagramScenarioContainerNodeParamBase {
  card: PutInstagramScenarioContainerNodeCardParam
}

export type PutInstagramScenarioContainerNodeParam =
  | PutInstagramScenarioContainerNodeParamBase
  | PutInstagramScenarioContainerNodeTextParam
  | PutInstagramScenarioContainerNodeMediaParam
  | PutInstagramScenarioContainerNodeCardParam

export interface PutInstagramScenarioContainerParamContainer {
  id: number | null
  stepOrder: number
  nodes: PutInstagramScenarioContainerNodeParam[]
}

export interface PutInstagramScenarioContainerParams {
  prizeId: number
  containers: PutInstagramScenarioContainerParamContainer[]
}

export type PutInstagramScenarioContainerResponse =
  | { data: true }
  | {
      error: {
        status: number
        type: string
        message: string
      }
    }

export async function putInstagramScenarioContainers(
  prizeId: number,
  containers: PutInstagramScenarioContainerParamContainer[]
): Promise<PutInstagramScenarioContainerResponse> {
  return await api.put<PutInstagramScenarioContainerResponse>('/instagram_instantwin_node_container', {
    prizeId,
    containers
  })
}
